import React, { useState } from "react";
import { COLOR } from "../../../Config/Color";
import AddShowAssets from "./Component/AddShowAssets";
import AssignAssetsDetails from "./Component/AssignAssetsDetails";
import { setAssetIndex } from "../../../Redux/Action";
import { useDispatch } from "react-redux";
import MainLayout from "../../../../layouts/MainLayout";

const AssetManagment = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("Assets Detail");
  const tabs = ["Assets Detail", "Assigned Assets"];
  return (
    <MainLayout>
      <div className="page-wrapper">
        <div className="content">
          <div className="newattendance-container">
            <div className="w-100 d-flex justify-content-between align-items-center">
              <h1 className="my-2 text-start fs-24 text-dark">
                Asset Management Page
              </h1>
            </div>
            <div className="flex items-center justify-between border-b border-gray-300 px-10 py-1 bg-white rounded-lg shadow-sm">
            <div className="d-flex align-items-center gap-3 py-2">
            {tabs.map((tab) => (
                  <button
                    key={tab}
                    onClick={() => {
                      setActiveTab(tab);
                      if (tab === "Assets Detail") {
                        dispatch(setAssetIndex(0));
                      } else {
                        dispatch(setAssetIndex(1));
                      }
                    }}
                    className={` font-bold ${activeTab === tab
                        ? "text-blue-600 border-b-2 border-blue-600"
                        : "text-[#78829D]" // Custom color for inactive tab
                      }`}
                  >
                    {tab}
                  </button>
                ))}
              </div>
            </div>

            <div style={{ marginTop: "20px", width: "100%" }}>
              {activeTab === "Assets Detail" && <AddShowAssets />}
              {activeTab === "Assigned Assets" && <AssignAssetsDetails />}
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default AssetManagment;
